<section
    data-testid="push-merch"
    [hAnimateOnScroll]="{
        animate: pushMerch.hasAnimation,
        threshold: 0.2
    }"
    [ngClass]="pushMerch.media && numberOfProducts < 4 ? 'block-standard-media' : 'block-hero-media'"
    class="fit-to-text-on-top"
    hDetectViewport
    (isInViewport)="sendImpression()">
    <div
        [ngClass]="[
            pushMerch.media ? 'with-media' : 'without-media',
            'grid-' + numberOfProducts + '-product',
            numberOfProducts >= 4 ? 'focus-order-' + pushMerch.merchandisingMediaPosition : ''
        ]">
        @if (pushMerch.token) { @if (pushMerch.media) {
        <h-media-cta
            class="block-media {{ pushMerch.merchandisingMediaPosition }}"
            [token]="pushMerch.token"
            [media]="pushMerch.media"
            [videoRatio]="'1-1'"
            [mediaOptions]="mediaOptions"></h-media-cta>
        } } @else { @if (pushMerch.media) {
        <h-media-cta
            class="block-media {{ pushMerch.merchandisingMediaPosition }}"
            [media]="pushMerch.media"
            [mediaOptions]="mediaOptions"
            [preloadPoster]="shouldPreloadMedia"
            [videoRatio]="'1-1'"></h-media-cta>
        } } @for (merchandisingProduct of pushMerch.merchandisingProducts; track merchandisingProduct; let position =
        $index) {
        <h-product-card
            [product]="merchandisingProduct"
            [ellipsisOnText]="!!pushMerch.media"
            (click)="sendProductClickEvent(merchandisingProduct, position + 1)">
        </h-product-card>
        }
    </div>
</section>
